import type { ConsentCategory, ConsentCollection } from '../types';

const availableConsents: ConsentCategory[] = [
  'affiliates',
  'analytics',
  'misc',
];

const createCollectionWithValue = (
  categoryValue: boolean,
): ConsentCollection => {
  return {
    affiliates: categoryValue,
    analytics: categoryValue,
    big_data: categoryValue,
    cdp: categoryValue,
    cookiematch: categoryValue,
    crm: categoryValue,
    display_ads: categoryValue,
    email: categoryValue,
    engagement: categoryValue,
    misc: categoryValue,
    mobile: categoryValue,
    monitoring: categoryValue,
    personalization: categoryValue,
    search: categoryValue,
    social: categoryValue,
  };
};

export const parseConsentCollectionString = (
  consent: string,
): ConsentCollection | undefined => {
  if (['yes', 'true', '1'].includes(consent)) {
    return createConsentCollectionFromConsentList(availableConsents);
  }

  const [versionString = undefined, attrsString = undefined] = consent.split('/');

  if (
    typeof versionString === 'undefined' ||
    typeof attrsString === 'undefined'
  ) {
    return undefined;
  }

  if (attrsString.length !== getSortedConsentCategoryNames().length) {
    return undefined;
  }

  const collection = createCollectionWithValue(false);

  getSortedConsentCategoryNames().forEach((category, idx) => {
    collection[category] = attrsString?.charAt(idx) === '1';
  });

  return collection;
};

const serializeConsentCollection = (collection: ConsentCollection): string => {
  const consentString = getSortedConsentCategoryNames()
    .map(category => {
      return collection[category] ? '1' : '0';
    })
    .join('');

  return `1/${consentString}`;
};

export const toLatestValidConsentString = (
  consent: string,
): string | undefined => {
  const categories = parseConsentCollectionString(consent);

  return categories ? serializeConsentCollection(categories) : undefined;
};
// const isValidConsentString = (consent: string): boolean => {
//   let [versionString = undefined, attrsString = undefined] = consent.split('/');
//
//   return versionString === '1' && attrsString?.length === 15;
// };

export const createConsentCollectionFromConsentList = (
  list: ConsentCategory[],
): ConsentCollection => {
  const collection = createCollectionWithValue(false);

  list.map(category => {
    collection[category] = true;
  });

  return collection;
};

export const consentCollectionToConsentList = (
  collection: ConsentCollection,
): ConsentCategory[] => {
  const list: ConsentCategory[] = [];

  (Object.keys(collection) as Array<keyof typeof collection>).forEach(
    category => {
      if (collection[category]) {
        list.push(category);
      }
    },
  );

  return list;
};

export const consentListsAreEqual = (
  listA: ConsentCategory[],
  listB: ConsentCategory[],
): boolean => {
  const matches = listA.filter(category => listB.includes(category));

  return matches.length === listA.length && listA.length === listB.length;
};

const getSortedConsentCategoryNames = (): ConsentCategory[] => {
  return [
    'affiliates',
    'analytics',
    'big_data',
    'cdp',
    'cookiematch',
    'crm',
    'display_ads',
    'email',
    'engagement',
    'misc',
    'mobile',
    'monitoring',
    'personalization',
    'search',
    'social',
  ];
};
